    <template>
  <nav>    
    <v-app-bar :dark="true" app  color="#E53935">
       <v-app-bar-nav-icon @click="drawer = !drawer" class="white--text"></v-app-bar-nav-icon>

      <v-toolbar-title class="text-uppercase white--text">
        <span>Tribunes SA</span><span class="font-weight-light"> App</span>
      </v-toolbar-title>

      <v-layout v-if="typeof UserRecord.id !== 'undefined'">
      
        <!-- <div id="notificationbar"> -->
          <v-list dark class="transparent">
                  <v-list-item>
                        <v-menu offset-y :close-on-content-click="false" bottom left>
                          <template v-slot:activator="{ on }">
                            <v-badge color="pop" overlap
                              dark>

                              <v-icon
                              dark
                              v-on="on">
                              mdi-bell-check
                            </v-icon>

                            <span slot="badge"> {{UnreadNotifications.length}} </span>
                            </v-badge>
                          </template>

                          <v-tabs dark>
                                <v-tab>Unread</v-tab>
                                <v-tab-item>
                                <v-list light v-if="UnreadNotifications.length>0">
                                  <h3 class="viewingnotificationheader">New Notifications</h3><br>
                                  <v-list-item v-for="notification in UnreadNotifications" :key="notification.itemObjKey" :class="{newbasicoutlined: !notification.Read}" @click="NotificationRead(notification)">
                                      <v-list-item-content class="notificationheader">
                                      {{notification.Header}}
                                      <p class="notificationcontent">{{notification.Message}}<span class="tooltiptext"><h4>{{notification.CreatorFullName}}</h4>{{notification.Content.substr(0, 50)}}</span></p>
                                    </v-list-item-content>
                                  </v-list-item>
                                </v-list>
                                <v-list class="viewingnotification" light v-if="UnreadNotifications.length===0">
                                  <h3 class="viewingnotificationheader">New Notifications</h3><br>
                                  <v-list-item>
                                    <v-list-item-content class="notificationheader">
                                      There are no new notifications<br>
                                      <p class="notificationcontent">Click on the "Read" tab to see Read notifications</p>
                                    </v-list-item-content>
                                  </v-list-item>
                                </v-list>
                                </v-tab-item>
                                <v-tab>Read</v-tab>
                                <v-tab-item>
                                <v-list class="viewingnotification" light v-if="ReadNotifications.length>0">
                                  <h3 class="viewingnotificationheader">Read Notifications</h3><br>
                                  <v-list-item v-for="notification in ReadNotifications" :key="notification.itemObjKey" :class="{newbasicoutlined: notification.Read}">
                                    <v-list-item-content class="notificationheader">
                                      {{notification.Header}}
                                      <p class="notificationcontent">{{notification.Message}}<span class="tooltiptext"><h4>{{notification.CreatorFullName}}</h4>{{notification.Content.substr(0, 50)}}</span></p>
                                    </v-list-item-content>
                                    <v-list-item-content>
                                      <v-btn small @click="MarkasUnread(notification)">Mark Unread</v-btn><v-btn small @click="ViewItem(notification)">View</v-btn>
                                    </v-list-item-content>
                                  </v-list-item>
                                </v-list>
                                <v-list class="viewingnotification" light v-if="ReadNotifications.length===0">
                                  <h3 class="viewingnotificationheader">Read Notifications</h3><br>
                                  <v-list-item>
                                    <v-list-item-content class="notificationheader">
                                      There are no Read notifications<br>
                                      <p class="notificationcontent">Click on the "Unread" tab to see New notifications</p>
                                    </v-list-item-content>
                                  </v-list-item>
                                </v-list>
                                </v-tab-item>
                              </v-tabs>

                            </v-menu>
                      </v-list-item> 
                  </v-list>          
          <!-- </div> -->
      <v-spacer></v-spacer>

      <v-layout class="justify-end">
        <v-list dark class="transparent">
          <v-list-item>
            <v-menu
                bottom
                left
                offset-y
                :close-on-content-click="false"
                >
                <template v-slot:activator="{ on }">
                <v-avatar v-on="on">
                  <img v-if="UserPicture "
                    :src="UserPicture "              
                  >
                  <img v-if="!UserPicture "
                    src="@/assets/blank-profile-picture-973460_640.png"              
                  >
                </v-avatar>
                </template>
                <v-list>
                  <v-list-item :to="'/MyProfile'">
                  <v-list-item-avatar>
                    <img v-if="UserPicture "
                    :src="UserPicture "              
                  >
                  <img v-if="!UserPicture "
                    src="@/assets/blank-profile-picture-973460_640.png"              
                  >
                  </v-list-item-avatar>
                    <v-list-item-content>
                      View My Profile
                    </v-list-item-content>
                  </v-list-item>
                  <v-list-item @click="ActivateTicketLog()">
                  <v-list-item-avatar>
                  <v-icon>mdi-ticket-confirmation</v-icon>
                  </v-list-item-avatar>
                  <v-list-item-content>
                      Log Ticket 
                    </v-list-item-content>
                  </v-list-item>
                  <v-list-item @click="ConfirmlogoutFromFirebase">
                  <v-list-item-avatar>
                  <v-icon>mdi-exit-to-app</v-icon>
                  </v-list-item-avatar>
                  <v-list-item-content>
                      Sign Out 
                    </v-list-item-content>
                  </v-list-item>
                </v-list>
              </v-menu>
          </v-list-item>
        </v-list>
      </v-layout>
      </v-layout>
    </v-app-bar >

    <v-navigation-drawer :dark="true"  temporary app v-model="drawer" color="#E53935">
      <v-list>
        <v-list-item @click="IntranetViewToggle">
          <v-icon dark>
              mdi-repeat
            </v-icon>Switch to Intranet
        </v-list-item>
        <v-divider></v-divider>
        <div v-for="link in items" :key="link.title">
          <v-list-item v-if="!link.Children || link.Children.length<0" :to="link.to" :target="link.target">
          <v-list-item-action>
            <v-icon >{{ link.icon }}
          </v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title :to="link.to" :target="link.target" >{{ link.title}}
            </v-list-item-title>
            </v-list-item-content>
             <v-list-item-action v-if="link.Page">
             <v-icon class="secondary--text">mdi-sitemap
           </v-icon>
           </v-list-item-action>
          </v-list-item>
            <v-list-group
              v-if="link.Children && link.Children.length"
              >
                <template v-slot:activator>
                  <v-list-item-action>
                  <v-icon class="white--text">{{ link.icon }}
                </v-icon>
                </v-list-item-action>
                  <v-list-item-title>{{link.title}}</v-list-item-title>
                </template>
                <div v-for="subsub in link.Children"
                        :key="subsub.itemObjKey">
                    <v-list-item class="mx-3" v-if="!subsub.Children || subsub.Children.length<0"
                        
                        :to="subsub.to" :target="subsub.target"
                    >          
                    <v-list-item-action>
                        <v-icon class="white--text">{{ subsub.icon }}
                      </v-icon>
                      </v-list-item-action>                          
                        <v-list-item-title>{{ subsub.title }}</v-list-item-title>
                    </v-list-item>
                    <v-list-group
                    sub-group
                      v-if="subsub.Children && subsub.Children.length"
                      >
                        <template v-slot:activator>
                          <!-- <v-list-item-action>
                          <v-icon class="white--text">{{ subsub.icon }}
                        </v-icon>
                        </v-list-item-action> -->
                          <v-list-item-title>{{subsub.title}}</v-list-item-title>
                        </template>
                        <v-list-item class="mx-3" v-for="subchild in subsub.Children" :key="subchild.itemObjKey"
                          :to="subchild.to" :target="subchild.target"
                      >          
                      <v-list-item-action>
                          <v-icon class="white--text">{{ subchild.icon }}
                        </v-icon>
                        </v-list-item-action>                          
                          <v-list-item-title>{{ subchild.title }}</v-list-item-title>
                      </v-list-item>
                    </v-list-group>
                </div>
              </v-list-group>
          </div>
      </v-list>

    </v-navigation-drawer>
    <v-dialog v-model="TicketLog" max-width="600px">
      <v-card width="100%">
        <SystemTicketsLogging @CancelSubmitSystemTicket="CancelSubmitSystemTicket" :UserRecord="UserRecord" :UsersArray="UsersArray" :RelatedObj="RelatedObj" :View="'Single'" />
      </v-card>
    </v-dialog>

  </nav>
</template>

<script>
import firebase from 'firebase';
import db from '@/main'
import BreadCrumbs from '@/components/BreadCrumbs'
import SystemTicketsLogging from '@/components/SystemTicketsLogging'

export default {
  components: {
  BreadCrumbs,
  SystemTicketsLogging
  },
  data() {
    return {
      TicketLog: false,
      UsersArray: [],
      drawer: false,
      items: [],
      UserFullName: '',
      UserPicture: '',
      UserAssignedRoles: {},
      hover: false,
      Notifications: [],
      ViewingNotificaitons: false,
      UserRecord: {},
    }
  },
  computed: {
      userLoggedIn () {
      return this.$store.getters.user
    },

    UnreadNotifications(){
      return this.Notifications.filter(notificaton => {
        return !notificaton.Read === true
      })
    },
    ReadNotifications(){
      return this.Notifications.filter(notificaton => {
        return notificaton.Read === true
      })
    }
    },

    watch: {
      userLoggedIn (value) {
        if (value === null || value === undefined) {
          this.$router.push('/login')
        }
        if (value !== null && value !== undefined) {
          this.$router.push('/')
        }
      }
    },

  created() {
    this.getUserAuthStateChange()

  },

  methods: {
  IntranetViewToggle(){
      confirm('This will take you to the Intranet version of the App, do you want to continue?') &&
        this.$emit('IntranetViewToggle',true)
      },
  CancelSubmitSystemTicket(){
      this.TicketLog = false
    },
      ActivateTicketLog(){
        this.UsersArray = [this.UserRecord]
        this.TicketLog = true
      },
    GetUserNotifications(query){
      query.get().then(res => {

      const changes = res.docChanges();
      changes.forEach(change => {
        if (change.type === 'added') {
          this.Notifications.push({
            ...change.doc.data(),
            id: change.doc.id
          })
        }
      })
    })
    },


     NotificationRead(notification){
      if(notification.Read === false){
       db.collection('notifications').doc(notification.id).update({
        Read: true
      })
      let notificationIndex = this.Notifications.indexOf(notification)
      this.Notifications[notificationIndex].Read = true
      this.$router.push(notification.Path)

      }

    },
    ViewItem(notification){
      this.$router.push(notification.Path)
    },

    MarkasUnread(notification){
      if(notification.Read === true && notification.Type === 'Task Created'){
       db.collection('notifications').doc(notification.id).update({
        Read: false
      })
      let notificationIndex = this.Notifications.indexOf(notification)
      this.Notifications[notificationIndex].Read = false


      }
    },

    ConfirmlogoutFromFirebase(){
      confirm('Are you sure you want to log out?') && this.logoutFromFirebase()
    },

    logoutFromFirebase () {
      this.Notifications = []
      this.UserRecord = {}
      this.$store.dispatch('signOutAction')
      this.$router.replace('/Login')
    },
    async getUserAuthStateChange() {
        var vm = this;

      await firebase.auth().onAuthStateChanged(function(user) {
  if (user) {
        //console.log('AuthchangeLoggedIn but not dispatching userstate')
        // console.log(user.uid)
        // vm.$store.dispatch('UserState',user)
      vm.items = [
          {
            icon: 'mdi-sign-direction',
            title: 'Welcome',
            to: '/Welcome',
            target: 'self'
          },
          {
            icon: 'mdi-clipboard-list-outline',
            title: 'Activities',
            to: '/Activities',
            target: 'self',
            Children: [
              {
            icon: 'mdi-bell-check',
            title: 'My Activities',
            to: '/MyActivities',
            target: 'self'
          },
          {
            icon: 'mdi-calendar',
            title: 'My Schedule',
            to: '/MySchedule',
            target: 'self'
          },
            {
            icon: 'mdi-calendar',
            title: 'My Team Schedule',
            to: '/MyTeamSchedule',
            target: 'self'
          },
            ]
          },
          {
            icon: 'mdi-sitemap',
            title: 'Pages',
            to: '/Pages',
            target: 'self',
            Children: [
            ]
          },
          {
            icon: 'mdi-database',
            title: 'Records',
            to: '/Records',
            target: 'self',
            Children: [
              ]
            },
            {
            icon: 'mdi-information-outline',
            title: 'System',
            to: '/System',
            target: 'self',
            Children: [
              {
              icon: 'mdi-road-variant',
              title: 'Roadmap',
              to: '/Roadmap',
              target: 'self'
            },
              {
              icon: 'mdi-ticket-confirmation',
              title: 'System Tickets',
              to: '/SystemTickets',
              target: 'self'

                },
              {
              icon: 'mdi-road-variant',
              title: 'Users',
              to: '/Users',
              target: 'self'
            },
            {
              icon: 'mdi-road-variant',
              title: 'BusinessUnits',
              to: '/BusinessUnits',
              target: 'self'
            }
              ]
            },
        ]
        let RecordsItem = vm.items.find(obj => obj.title === 'Records')
          let RecordItemIndex = vm.items.indexOf(RecordsItem)
        db.collection('users').doc(user.uid).onSnapshot(snapshot => {
          var userdetails = snapshot.data()
          vm.UserRecord = userdetails
             vm.UserRecord.id = user.uid
          if(vm.UserRecord.IsTeamActivityManager){
              let MyTeamActivitiesitemobject = {
              icon: 'mdi-contacts',
              title: 'My Team Activities',
              to: '/MyTeamActivities',
            target: 'self'
            }
          let parent = vm.items.find(obj => obj.title === 'Activities')
          let parentindex = vm.items.indexOf(parent)
           vm.items[parentindex].Children.push(MyTeamActivitiesitemobject)
          }
          let query = db.collection('notifications').where('Ownerid', '==', vm.UserRecord.id)
          vm.GetUserNotifications(query)
          vm.UserFullName = userdetails.Name+' '+userdetails.Surname
          vm.UserPicture = userdetails.profilephoto
          if(typeof userdetails.rolesarrayQuery !== 'undefined'){
          vm.UserAssignedRoles = userdetails.rolesarrayQuery
          
          let AdminTest = vm.UserAssignedRoles .find(obj => obj === 'System Admin')
                if(typeof AdminTest !== 'undefined'){
                
                }
          let DefaultAllroletest = vm.UserAssignedRoles.find(obj => obj === 'Default All')
      if(typeof DefaultAllroletest !== 'undefined'){
      
      }
          let DefaultUnitDownroletest = vm.UserAssignedRoles.find(obj => obj === 'Default Unit Down')
      if(typeof DefaultUnitDownroletest !== 'undefined'){
      
      }
          let DefaultUnitroletest = vm.UserAssignedRoles.find(obj => obj === 'Default Unit')
      if(typeof DefaultUnitroletest !== 'undefined'){
      
      }
          let DefaultOwnerroletest = vm.UserAssignedRoles.find(obj => obj === 'Default Owner')
      if(typeof DefaultOwnerroletest !== 'undefined'){
      
      }
          let DefaultCreateAllroletest = vm.UserAssignedRoles.find(obj => obj === 'Default Create All')
      if(typeof DefaultCreateAllroletest !== 'undefined'){
      
      }
          let DefaultgetAllroletest = vm.UserAssignedRoles.find(obj => obj === 'Default get All')
      if(typeof DefaultgetAllroletest !== 'undefined'){
      
      }
          let DefaultlistAllroletest = vm.UserAssignedRoles.find(obj => obj === 'Default list All')
      if(typeof DefaultlistAllroletest !== 'undefined'){
      
      }
          let DefaultdeleteALLroletest = vm.UserAssignedRoles.find(obj => obj === 'Default delete ALL')
      if(typeof DefaultdeleteALLroletest !== 'undefined'){
      
      }
          let DefaultupdateALLroletest = vm.UserAssignedRoles.find(obj => obj === 'Default update ALL')
      if(typeof DefaultupdateALLroletest !== 'undefined'){
      
      }
          let Defaultcreateunitdownroletest = vm.UserAssignedRoles.find(obj => obj === 'Default create unitdown')
      if(typeof Defaultcreateunitdownroletest !== 'undefined'){
      
      }
          let DefaultgetUnitDownroletest = vm.UserAssignedRoles.find(obj => obj === 'Default get UnitDown')
      if(typeof DefaultgetUnitDownroletest !== 'undefined'){
      
      }
          let DefaultlistUnitDownroletest = vm.UserAssignedRoles.find(obj => obj === 'Default list UnitDown')
      if(typeof DefaultlistUnitDownroletest !== 'undefined'){
      
      }
          let DefaultdeleteUnitDownroletest = vm.UserAssignedRoles.find(obj => obj === 'Default delete UnitDown')
      if(typeof DefaultdeleteUnitDownroletest !== 'undefined'){
      
      }
          let DefaultupdateUnitDownroletest = vm.UserAssignedRoles.find(obj => obj === 'Default update Unit Down')
      if(typeof DefaultupdateUnitDownroletest !== 'undefined'){
      
      }
          let DefaultgetUserUnitroletest = vm.UserAssignedRoles.find(obj => obj === 'Default get UserUnit')
      if(typeof DefaultgetUserUnitroletest !== 'undefined'){
      
      }
          let DefaultlistUserUnitroletest = vm.UserAssignedRoles.find(obj => obj === 'Default list UserUnit')
      if(typeof DefaultlistUserUnitroletest !== 'undefined'){
      
      }
          let DefaultcreateUserUnitroletest = vm.UserAssignedRoles.find(obj => obj === 'Default create UserUnit')
      if(typeof DefaultcreateUserUnitroletest !== 'undefined'){
      
      }
          let DefaultupdateUserUnitroletest = vm.UserAssignedRoles.find(obj => obj === 'Default update UserUnit')
      if(typeof DefaultupdateUserUnitroletest !== 'undefined'){
      
      }
          let DefaultdeleteUserUnitroletest = vm.UserAssignedRoles.find(obj => obj === 'Default delete UserUnit')
      if(typeof DefaultdeleteUserUnitroletest !== 'undefined'){
      
      }
          }
        })


    }

   else {
        //console.log('AuthchangeLoggedOut')
        vm.pushLoggedOutItems

      vm.items = [

        {
          icon: 'mdi-login-variant',
          title: 'Login',
          to: '/Login',
          target: 'self'
        },
              {
                icon: 'mdi-apps',
                title: 'Home',
                to: '/',
                target: 'self',
                Page: true
              },
              {
                icon: 'mdi-chess-knight',
                title: 'Debt Counselling',
                to: '/DebtCounselling',
                target: 'self',
                Page: true
              },
              {
                icon: 'mdi-deskphone',
                title: 'Contact Us',
                to: '/ContactUs',
                target: 'self',
                Page: true
              },
              {
                icon: 'mdi-chess-queen',
                title: 'Rehabilitation',
                to: '/Rehabilitation',
                target: 'self',
                Page: true
              },
              {
                icon: 'mdi-help',
                title: 'Services',
                to: '/Services',
                target: 'self',
                Page: true
              },
              {
                icon: 'mdi-chess-rook',
                title: 'Liquidation',
                to: '/Liquidation',
                target: 'self',
                Page: true
              },
              {
                icon: 'mdi-chess-king',
                title: 'Voluntary Sequestration',
                to: '/VoluntarySequestration',
                target: 'self',
                Page: true
              },
      ]

  }
    })
    }

  }

}
</script>

<style>
.notifications .viewingnotification {

  width: 250px;
  outline: 1px solid #dedee9;
  color: black;
  text-align: center;
  padding: 10px;
  font-size: 15px;



  /* Position the tooltip */
  position: absolute;
  z-index: 100;
}
.notificationcontent {
  font-size: 12px;
  color: black;
  text-align: left;
}
.notificationcontent .tooltiptext {
  visibility: hidden;
  min-width: 250px;
  width: auto;
  background-color: rgb(0, 153, 255);
  color: white;
  text-align: center;
  border-radius: 6px;
  font-size: 15px;
  padding: 15px 0;

  /* Position the tooltip */
  position: absolute;
  z-index: 100;
}

.notificationcontent:hover .tooltiptext {
  visibility: visible;
}
.notificationheader {
  color: black;
  text-align: left;
}
.viewingnotificationheader{
  align-self: left;
  border: 1px solid #dedee9;
  padding: 10px;
  background-color: rgb(0, 153, 255);
  color: white;
}
/* .notificationtabs{
  padding: 150px;
  margin-top: 1000px;
} */
/* .notifications{
  padding: 150px;
  margin-top: 100px;
} */
.basicoutlined{
  border: 1px solid #dedee9;
  outline: 1px solid #dedee9;
  color: black
}
.newbasicoutlined{

  border: 1px solid #dedee9;
  outline: 1px solid #dedee9;
}
.outline {

  border: 1px solid #dedee9;
  outline: 1px solid #dedee9;
}
/* #notificationbar {
  position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    width: 72%;
    height: 30%;
    margin: auto;
}
#navbaravatar{
  position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 1;
    width: 70%;
    height: 30%;
    margin: auto;
} */

</style>
    